import { QueryCache, QueryClient } from '@tanstack/react-query';

import { is401Error, is403Error, is404Error, isConsentError } from '../error-code/error-code';
import { consentQueryKey } from '../query-hooks/consent';

import type { AuthorizationProvider } from '../authorization/authorization-provider';

export const createQueryClient = (
    refetchOnWindowFocus: boolean,
    logout?: AuthorizationProvider['logout'],
): QueryClient => {
    const isRetryable = (error: unknown): boolean => !is403Error(error) && !is404Error(error) && !is401Error(error);

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                networkMode: 'always',
                refetchOnWindowFocus,
                retry: (failureCount, error) => failureCount < 2 && isRetryable(error),
                throwOnError: (error: unknown) => !isConsentError(error) && !is401Error(error),
            },
        },
        queryCache: new QueryCache({
            onError: async (error: unknown): Promise<void> => {
                if (isConsentError(error)) {
                    return queryClient.refetchQueries({ queryKey: consentQueryKey });
                }

                if (is401Error(error)) {
                    logout?.();

                    return;
                }
            },
        }),
    });

    return queryClient;
};
